import {FormattedDate, FormattedMessage, FormattedTime, injectIntl, intlShape} from 'react-intl';
import React, {Component} from 'react';
import PropTypes from 'prop-types';

import styles from './css/SupplierOrders.scss';

@injectIntl
export default class SupplierOrders extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        order: PropTypes.any,
        service: PropTypes.any
    }

    render() {
        const {order} = this.props;

        if (!order.has('supplierOrders')) {
            return null;
        }

        return (
            <div>
                {
                    order.get('supplierOrders')
                        .map((supplierOrder, i) => {
                            // const serviceMode = supplierOrder.getIn(['service', 'mode']);
                            const serviceAlias = order.get('service').get('alias');
                            const supplierServiceAlias = supplierOrder.getIn(['supplierService', 'alias']);

                            const list = supplierOrder.get('statusHistory') ? supplierOrder.get('statusHistory').map((status, j) => (
                                <li key={j} className={styles.item}>
                                    <span className={styles.status}>
                                        <FormattedMessage id={status.get('status')}/>
                                    </span>
                                    <span>
                                        <FormattedDate day='2-digit' year='numeric' month='long'
                                            value={status.get('createdAt')}/>
                                        &nbsp;
                                        <FormattedTime value={status.get('createdAt')}/>
                                    </span>
                                </li>
                            )) : null;

                            return (
                                <div key={i}>
                                    <h3>
                                        #{i + 1} <FormattedMessage id={supplierServiceAlias}/> <FormattedMessage
                                            id={serviceAlias}/>
                                    </h3>
                                    <ul className={styles.list}>
                                        {list}
                                    </ul>
                                </div>
                            );
                        })
                        .toArray()
                }
            </div>
        );
    }
}
